import CustomColumnContainer, {
  CustomColumnProps
} from './custom-column-container';

interface CustomColumnPlainTextProps extends CustomColumnProps {
  id?: string;
  text?: string;
  onEdit?: (id?: string) => void;
}

const CustomColumnPlainText = ({
  onEdit = () => {},
  ...props
}: CustomColumnPlainTextProps) => {
  const onEditHandler = (id: string) => {
    onEdit(id);
  };
  return (
    <CustomColumnContainer
      columnClass={props?.columnClass}
      containerClass={props?.containerClass}>
      <span className={'fw-bold'}>{props.text}</span>
      <span
        onClick={() => onEditHandler(props.id!)}
        className={'material-symbols-outlined'}
        style={{ cursor: 'pointer' }}>
        edit
      </span>
    </CustomColumnContainer>
  );
};

export default CustomColumnPlainText;
